import { render, staticRenderFns } from "./multi-radio-field.vue?vue&type=template&id=c3157bc2&scoped=true&"
import script from "./multi-radio-field.vue?vue&type=script&lang=js&"
export * from "./multi-radio-field.vue?vue&type=script&lang=js&"
import style0 from "./multi-radio-field.vue?vue&type=style&index=0&id=c3157bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3157bc2",
  null
  
)

export default component.exports